import {Injectable} from '@angular/core';

export interface InternalStateType {
    [key: string]: any
}

@Injectable()
export class AppState {
    _state: InternalStateType = {};

    private static _clone(object: InternalStateType) {
        // simple object clone
        return JSON.parse(JSON.stringify(object));
    }

    static state() {
        throw new Error('do not mutate the `.state` directly');
    }

    constructor() {

    }

    get state() {
        return this._state = AppState._clone(this._state);
    }

    get(prop?: any) {
        const state = this.state;
        return state.hasOwnProperty(prop) ? state[prop] : state;
    }

    set(prop: string, value: any) {
        return this._state[prop] = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts